import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faQrcode, faCheck, faArrowLeft, faCalendar, faClock, faLocationDot, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { NavbarBrand, Alert, Button, Modal, ModalHeader, ModalBody, ModalFooter, Toast, ToastHeader, ToastBody } from 'reactstrap';
import moment from 'moment';
import { NumericFormat, PatternFormat } from 'react-number-format';
import useApiFetch from '../../ApiFetch';
import useIsAuthenticated from 'react-auth-kit/hooks/useIsAuthenticated';
import useAuthUser from 'react-auth-kit/hooks/useAuthUser';
import MyPass from './MyPass';
import EventGuests from './EventGuests';

export default function Kiosk(props) {
    const { event, retrievePass, viewPass } = props;
    const { eventCode, registrationCode, passCode } = useParams();
    const params = useParams();
    const navigate = useNavigate();
    const apiFetch = useApiFetch();
    const isAuthenticated = useIsAuthenticated();
    const authUser = useAuthUser();

    const myPassRef = useRef(null);
    const timerRef = useRef(null); // Store timer ID

    const [loading, setLoading] = useState(false);
    const [eventData, setEventData] = useState([]);
    const [modal, setModal] = useState(true);

    const [modalCode, setModalCode] = useState(false);
    const [regCode, setRegCode] = useState('');
    const [invalidCode, setInvalidCode] = useState(null);

    const [validated, setValidated] = useState(false);
    const [registration, setRegistration] = useState({ firstName: '', lastName: '', email: '', company: '', phone: '', optin: true });
    const [registering, setRegistering] = useState(false);
    const [registeredData, setRegisteredData] = useState(null);
    const [isRegistered, setIsRegistered] = useState(false);

    const [modalRetrievePass, setModalRetrievePass] = useState(false);
    const [retrievePassEmail, setRetrievePassEmail] = useState('');
    const [retrievingPass, setRetrievingPass] = useState(false);
    const [retrieved, setRetrieved] = useState(false);

    const modalToggle = () => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        setModal(!modal)
        setRegisteredData(null);
        setValidated(false);
        setRegistering(false);
        //    if (!isAuthenticated())
        //        setRegistration({ firstName: '', lastName: '', email: '', company: '', phone: '' });
    };
    useEffect(() => {
        setLoading(true);
        setRegistering(false);

        getData();

    }, []);
    const getData = async () => {
        await apiFetch.get('/api/event/' + encodeURIComponent(eventCode))
            .then(resp => {
                setEventData(resp.data);
                if (isAuthenticated() && resp.data) {
                    apiFetch.get('/api/event/' + encodeURIComponent(eventCode) + '/isregistered')
                        .then(resp => {
                            setIsRegistered(resp.data);
                        });
                }
                setLoading(false);
            });
    };
    const handleRegister = async (event) => {
        const form = event.currentTarget;
        if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
        }
        else {
            event.preventDefault();
            event.stopPropagation();

            setRegistering(true);
            let regObj = registration;
            if (isAuthenticated() && authUser && authUser.user) {
                regObj.userId = authUser.user.id;
            }
            await apiFetch.post('/api/event/' + encodeURIComponent(eventCode) + '/register', regObj)
                .then(resp => {
                    setRegisteredData(resp.data);
                    setRegistering(false);
                    // Set a delayed message
                    timerRef.current = setTimeout(() => {
                        resetForm();
                    }, 15000);
                });
        }
        setValidated(true);
    };
    const resetForm = () => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        setRegisteredData(null);
        setRegistration({ firstName: '', lastName: '', email: '', company: '', phone: '', optin: true });
        setValidated(false);
        setRegistering(false);
    };

    const handlePatternFormatChange = (values, sourceInfo) => {
        if (sourceInfo.source !== 'event') {
            return;
        }
        setRegistration({ ...registration, [sourceInfo.event.target.name]: values.value })
    };

    const handleRegisterButton = () => {
        setRegistration({ firstName: '', lastName: '', email: '', company: '', phone: '', optin: true });
        modalToggle();
    };

    return (
        <>

            <div className="py-5 text-center h-100 align-items-center justify-content-center" onClick={handleRegisterButton}>
                <img className="d-block mx-auto mb-4" src="./assets/images/hyetech_logo2_4color.png" alt="" height="200" />
            </div>
            <Modal isOpen={modal} toggle={modalToggle} size="xl" fullscreen={true} fade={true}>
                <ModalHeader toggle={modalToggle} style={{ backgroundColor: '#1295d8' }} className="py-1">
                    <NavbarBrand className="my-0">
                        <img src="/assets/images/hyetech_logo2_4color.png" alt="HyeTech" height="30" />
                        <span className="ms-1 h6" style={{ lineHeight: '30px' }}>HyeTech Events</span>
                    </NavbarBrand>
                </ModalHeader>
                <ModalBody className="">
                    {registeredData ?
                        <div className="py-5 text-center h-100" onClick={resetForm}>
                            <img className="d-block mx-auto mb-4" src="./assets/images/hyetech_logo2_4color.png" alt="" height="200" />
                            <h2 className="text-success">Success!</h2>
                            <p className="lead">
                                You have successfully registered for this event.
                            </p>
                        </div>
                        :
                        <>
                            <div className="container-xl col-xxl-10 px-4 pt-1 pb-5 ">
                            <div className="card mb-3">
                                <div className="row flex-lg-row align-items-center g-0 py-0 shadow-lg">
                                        <div className="col-12 col-sm-12 col-md-4 col-lg-4 text-center">
                                            <img style={{ maxHeight: '200px' }} src={eventData && eventData.imageUrl ? eventData.imageUrl : './assets/images/hyetech_logo2_4color.png'} className="img-fluid rounded-start" alt="..." />

                                    </div>
                                    <div className="col-12 col-sm-12 col-md-8 col-lg-8 ps-4 ">
                                        <div className="card-body">
                                            <h1 className="display-5 fw-bold text-body-emphasis lh-1 mb-3">{eventData.title}</h1>
                                            {/*<p className="lead pt-3">*/}
                                            {/*    <FontAwesomeIcon icon={faCalendar} /> {getEventDates()} &nbsp;*/}
                                            {/*    {getEventTimes() ? <><FontAwesomeIcon icon={faClock} /> {getEventTimes()}</> : null}*/}
                                            {/*    {eventData.venue || eventData.room*/}
                                            {/*        ?*/}
                                            {/*        <>*/}
                                            {/*            <br />*/}
                                            {/*            <FontAwesomeIcon icon={faLocationDot} />&nbsp;*/}
                                            {/*            {eventData.venue ?? eventData.room}*/}
                                            {/*        </>*/}
                                            {/*        :*/}
                                            {/*        null}*/}
                                            {/*</p>*/}
                                        </div>
                                    </div>
                                </div>
                                </div>
                                <div className="row d-flex justify-content-center ">
                                <div className="col-xl-6 col-lg-6 align-self-center">
                                    <h4 className="mb-3 text-center">Welcome!</h4>
                                    <form noValidate className={`needs-validation ${validated ? 'was-validated' : ''}`} onSubmit={handleRegister}>
                                        <div className="row g-3">
                                            <div className="col-sm-6">
                                                <label htmlFor="firstName" className="form-label">First Name</label>
                                                <input type="text" name="firstName" value={registration.firstName} onChange={(e) => setRegistration({ ...registration, [e.target.name]: e.target.value })} className="form-control" id="firstName" required />
                                                <div className="invalid-feedback">
                                                    Valid first name is required.
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <label htmlFor="lastName" className="form-label">Last Name</label>
                                                <input type="text" name="lastName" value={registration.lastName} onChange={(e) => setRegistration({ ...registration, [e.target.name]: e.target.value })} className="form-control" id="lastName" placeholder="" required />
                                                <div className="invalid-feedback">
                                                    Valid last name is required.
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <label htmlFor="Company" className="form-label">Company</label>
                                                <input type="text" name="company" value={registration.company} onChange={(e) => setRegistration({ ...registration, [e.target.name]: e.target.value })} className="form-control" id="Company" placeholder="" required />
                                                <div className="invalid-feedback">
                                                    Your company is required.
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <label htmlFor="email" className="form-label">Email</label>
                                                <input type="email" name="email" value={registration.email} onChange={(e) => setRegistration({ ...registration, [e.target.name]: e.target.value })} className="form-control" id="email" placeholder="you@company.com" required />
                                                <div className="invalid-feedback">
                                                    Please enter a valid email address.
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <label htmlFor="phone" className="form-label">Phone</label>
                                                <PatternFormat name="phone" onValueChange={handlePatternFormatChange} className="form-control" id="phone" format="+1 (###) ###-####" value={registration.phone} valueIsNumericString={true} allowEmptyFormatting mask="_" />
                                                <div className="invalid-feedback">
                                                    Please enter a valid phone number.
                                                </div>
                                            </div>
                                        </div>
                                        <hr className="my-4" />
                                        {/*{eventData?.supportsGuests &&*/}
                                        {/*    <div className="text-center">*/}
                                        {/*        This event allows registrants to bring guests.<br />Would you like to bring guests?*/}
                                        {/*        <EventGuests event={eventData} registrationId={registeredData?.id} updatedGuests={eventGuestsUpdated} />*/}
                                        {/*        <hr className="my-4" />*/}
                                        {/*    </div>*/}
                                        {/*}*/}

                                        <button className="w-100 btn btn-primary btn-lg" type="submit" disabled={registering}>
                                            {registering ? <FontAwesomeIcon icon={faSpinner} className='me-3' spin /> : null}
                                            Register
                                        </button>
                                        <small>
                                            <div className="row g-0 justify-content-center ">
                                                <div className="col-auto mb-0 mt-1 pb-0">
                                                    <div className="form-check mb-0">
                                                        <small>
                                                            <input className="form-check-input mt-1" style={{}} type="checkbox" id="chkOptin" name="optin" checked={registration.optin ?? true} onChange={(e) => setRegistration({ ...registration, [e.target.name]: e.target.checked })} required={false} />
                                                            <label className="form-check-label" htmlFor="chkOptin" style={{ color: 'inherit' }}>
                                                                Yes, I'd like to receive newsletters and invitations to future events.
                                                            </label>
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>
                                        </small>
                                    </form>
                                    </div>
                                </div>
                            </div>

                        </>
                    }

                </ModalBody>
            </Modal>
        </>
    );
};
